import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StyledFilterContainer from 'flow-doctor-lib/components/filters/StyledFilterContainer';
import WalmartAdsSearchFilterRenderer from 'flow-doctor-lib/components/filters/WalmartAdsSearchFilterRenderer';
import WalmartAdsTimeFilterRenderer from 'flow-doctor-lib/components/filters/WalmartAdsTimeFilterRenderer';
import WalmartCTAFilterRenderer from 'flow-doctor-lib/components/filters/WalmartCTAFilterRenderer';
import WalmartEmailEventFilterRenderer from 'flow-doctor-lib/components/filters/WalmartEmailEventFilterRenderer';
import WalmartEmailSubscriptionFilterRenderer from 'flow-doctor-lib/components/filters/WalmartEmailSubscriptionFilterRenderer';
import WalmartFormSubmissionFilterRenderer from 'flow-doctor-lib/components/filters/WalmartFormSubmissionFilterRenderer';
import WalmartInListFilterRenderer from 'flow-doctor-lib/components/filters/WalmartInListFilterRenderer';
import WalmartIntegrationFilterRenderer from 'flow-doctor-lib/components/filters/WalmartIntegrationFilterRenderer';
import WalmartLegacyEventFilterRenderer from 'flow-doctor-lib/components/filters/WalmartLegacyEventFilterRenderer';
import WalmartPageViewFilterRenderer from 'flow-doctor-lib/components/filters/WalmartPageViewFilterRenderer';
import WalmartPropertyFilterRenderer from 'flow-doctor-lib/components/filters/WalmartPropertyFilterRenderer';
import WalmartSurveyMonkeyFilterRenderer from 'flow-doctor-lib/components/filters/WalmartSurveyMonkeyFilterRenderer';
import WalmartWebinarFilterRenderer from 'flow-doctor-lib/components/filters/WalmartWebinarFilterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MissingFilterComponent = ({
  filter
}) => /*#__PURE__*/_jsx("i", {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "flow-doctor-lib.filters.unhandled",
    options: {
      filterType: filter.filterType
    }
  })
});
const WalmartFilterRenderer = ({
  filterAdapter,
  objectTypeId,
  filterWidthType,
  fallbackFilterElement
}) => {
  const filterToDisplay = filterAdapter.getFilter();
  const filterComponent = (() => {
    switch (filterToDisplay.filterType) {
      case 'PROPERTY':
        return /*#__PURE__*/_jsx(WalmartPropertyFilterRenderer, {
          filter: filterToDisplay,
          objectTypeId: objectTypeId
        });
      case 'EMAIL_SUBSCRIPTION':
        return /*#__PURE__*/_jsx(WalmartEmailSubscriptionFilterRenderer, {
          filter: filterToDisplay
        });
      case 'IN_LIST':
        return /*#__PURE__*/_jsx(WalmartInListFilterRenderer, {
          filter: filterToDisplay
        });
      case 'ADS_SEARCH':
        return /*#__PURE__*/_jsx(WalmartAdsSearchFilterRenderer, {
          filter: filterToDisplay
        });
      case 'ADS_TIME':
        return /*#__PURE__*/_jsx(WalmartAdsTimeFilterRenderer, {
          filter: filterToDisplay
        });
      case 'FORM_SUBMISSION':
      case 'FORM_SUBMISSION_ON_PAGE':
        return /*#__PURE__*/_jsx(WalmartFormSubmissionFilterRenderer, {
          filter: filterToDisplay
        });
      case 'PAGE_VIEW':
        return /*#__PURE__*/_jsx(WalmartPageViewFilterRenderer, {
          filter: filterToDisplay
        });
      case 'EMAIL_EVENT':
        return /*#__PURE__*/_jsx(WalmartEmailEventFilterRenderer, {
          filter: filterToDisplay
        });
      case 'CTA':
        return /*#__PURE__*/_jsx(WalmartCTAFilterRenderer, {
          filter: filterToDisplay
        });
      case 'WEBINAR':
        return /*#__PURE__*/_jsx(WalmartWebinarFilterRenderer, {
          filter: filterToDisplay
        });
      case 'SURVEY_MONKEY':
      case 'SURVEY_MONKEY_VALUE':
        return /*#__PURE__*/_jsx(WalmartSurveyMonkeyFilterRenderer, {
          filter: filterToDisplay
        });
      case 'INTEGRATION_EVENT':
        return /*#__PURE__*/_jsx(WalmartIntegrationFilterRenderer, {
          filter: filterToDisplay
        });
      case 'EVENT':
        return /*#__PURE__*/_jsx(WalmartLegacyEventFilterRenderer, {
          filter: filterToDisplay
        });
      default:
        if (fallbackFilterElement) {
          return fallbackFilterElement;
        }
        return /*#__PURE__*/_jsx(MissingFilterComponent, {
          filter: filterToDisplay
        });
    }
  })();
  const details = filterAdapter.renderDetailsComponent(objectTypeId);
  if (details) {
    return /*#__PURE__*/_jsxs("div", {
      style: {
        display: 'flex',
        flexDirection: 'column'
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        },
        children: details
      }), /*#__PURE__*/_jsxs(StyledFilterContainer, {
        filterWidthType: filterWidthType,
        backgroundColor: filterAdapter.getBackgroundColor(),
        children: [filterComponent, filterAdapter.renderEvalutionValueComponent(objectTypeId)]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(StyledFilterContainer, {
    filterWidthType: filterWidthType,
    backgroundColor: filterAdapter.getBackgroundColor(),
    children: [filterComponent, filterAdapter.renderEvalutionValueComponent(objectTypeId)]
  });
};
export default WalmartFilterRenderer;